import { render, staticRenderFns } from "./order.vue?vue&type=template&id=5f9f945a&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order.vue?vue&type=style&index=1&id=5f9f945a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9f945a",
  null
  
)

export default component.exports